import { EuiComboBox, EuiComboBoxProps } from "@inscopix/ideas-eui";
import { withUserPermission } from "hocs/withUserPermission";
import { withUserPermissionBase } from "hocs/withUserPermissionBase";

/**
 * {@link EuiComboBox} represented as a function component. This is necessary
 * because TypeScript only supports propagating generic type arguments with
 * functions, not classes.
 */
const EuiComboBoxFC = <T extends string>(props: EuiComboBoxProps<T>) => (
  <EuiComboBox {...props} />
);

/**
 * Enhanced {@link EuiComboBox} that is disabled when the user lacks a
 * required permission.
 *
 * Context independent.
 */
export const ComboBoxPermissionedBase = withUserPermissionBase(EuiComboBoxFC);

/**
 * Enhanced {@link EuiComboBox} that is disabled when the user lacks a
 * required permission.
 *
 * Reads permissions from project permissions context.
 */
export const ComboBoxPermissioned = withUserPermission(
  ComboBoxPermissionedBase,
);
